export enum EPatientDataSource {
	vitale = "vitale",
	ADRi = "ADRi"
}
